"use client";
import { createContext, useRef } from "react";

export const HeaderContext = createContext<React.RefObject<HTMLDivElement> | null>(null);

export function HeaderProvider({ children }: { children: React.ReactNode }) {
  const headerRef = useRef<HTMLDivElement>(null);

  return (
    <HeaderContext.Provider value={headerRef}>
      {children}
    </HeaderContext.Provider>
  );
}
